export const TYPE_ALGEMEEN = 1;
export const TYPE_EXAMEN = 2;
export const TYPE_STICHTING = 3;
export const TYPE_TAALEXAMEN = 4;
